// Русские строки интерфейса — исходный текст, как он был зашит в компонентах.
// Это язык по умолчанию и fallback: если ключа нет в другом словаре, покажется отсюда.
export default {
  common: {
    all: "Все",
    yes: "Да",
    no: "Нет",
    save: "Сохранить",
    saving: "Сохраняем…",
    saved: "Сохранено",
    add: "Добавить",
    delete: "Удалить",
    send: "Отправить",
    update: "Обновить",
    loading: "Загружаем…",
    failed: "Не получилось",
    notSet: "не настроено",
    name: "Название",
    enterText: "Ввести текст",
    activity: "Активность",
  },

  region: {
    europe: "Европа",
    australia: "Австралия",
    canada: "Канада",
    poland: "Польща",
    germany: "Германия",
    france: "Франция",
    romania: "Румыния",
  },

  nav: {
    telegram: "Telegram",
    telegramAlerts: "Telegram: CR, FTD alerts!",
    telegramReconciliation: "Telegram: Сверка",
    rules: "Правила работы",
    users: "Пользователи",
    addFbId: "Добавить FB id",
    teams: "Команды",
    buyerStats: "Cтатистика Баеров",
    countryStats: "Cтатистика Стран",
    campaignReport: "Сampaign Report",
    clients: "Клиенты",
    integrations: "Интеграции",
    blockedCountries: "Запрещенные страны",
    countersHistory: "История счетчиков",
    integrationResponses: "Ответы партнёров",
    leads: "Лиды",
    leadsUtm: "Лиды UTM",
    leadsQueue: "Лиды в очереди",
    leadStats: "Статистика Лидов",
    depositStats: "Статистика Депозитов",
    sendLead: "Отправить Лид",
    api: "API",
    spending: "Расходы",
  },

  header: {
    queue: "Очередь",
    queueDisable: "Отключить очеридь распределения лидов!",
    queueEnable: "Включить очеридь распределения лидов!",
    logout: "Выйти",
  },

  home: {
    title: "Главная",
  },

  lead: {
    breadcrumb: "Лид",
    listTitle: "Список Лидов",
    queueTitle: "Список лидов в очереди на отправку",
    assignManually: "Назначить вручную",
    byCreatedDate: "Дате создания",
    bySuccessDate: "Дате успеха",
  },

  stopReason: {
    title: "Почему лид остановился",
    empty: "Распределитель не фиксировал отказ по этому лиду.",
    integration: "Интеграция {id}",
    selection: "Отбор",
    lastCheck: "Последняя проверка: {date}",
    retry: "Лид в очереди повтора: попыток {attempts}, следующая {date}.",
    retryDisabled: "Отложенный повтор дублей выключен — лид сам в очередь не встанет.",
  },

  quotas: {
    label: "Команды и доли внутри интеграции",
    hintMode:
      "Пока стоит «Все команды», интеграция работает как раньше. «Только выбранные» — лид чужой команды пропускает эту интеграцию и идёт в следующую подходящую.",
    modeAll: "Все команды",
    modeSelected: "Только выбранные",
    allowWithoutTeam: "Пускать лиды без команды",
    splitBuyerQuota: "Делить долю команды между байерами",
    releaseHour: "Час освобождения (UTC)",
    releaseHourPlaceholder: "нет",
    hintRelease:
      "С часа освобождения доли не проверяются — остаток капы забирает любая допущенная команда. Допуск команд и байеров работает круглосуточно. Пусто — не освобождать.",
    colAllow: "Пускать",
    colTeam: "Команда",
    colShare: "Доля, %",
    colQuota: "Квота, лидов",
    colAcceptedToday: "Сегодня принято",
    colInProgress: "В работе",
    collapse: "свернуть",
    buyers: "байеры",
    loadingBuyers: "Загружаем байеров…",
    noBuyers: "В команде нет байеров.",
    hintBuyers:
      "Если внутри команды не отмечен никто — проходят все её байеры. Отметили хотя бы одного — проходят только отмеченные.",
    withoutTeam: "Без команды",
    allowed: "пускаем",
    notAllowed: "не пускаем",
    summary: "сумма долей допущенных команд:",
    saveQuotas: "Сохранить квоты",
    warnBlocked: "Интеграция перестанет принимать лиды команд: {teams}.",
    warnAllSelected:
      "Режим «Только выбранные» включится, но отмечены все команды — поток не изменится.",
    warnWithoutTeam: "Лиды без команды эту интеграцию проходить не будут.",
    warnOverCap:
      "Сумма долей {percent}% больше капы: команды будут конкурировать за одни и те же места.",
    warnUnderCap: "Распределено {percent}% капы: остаток выдаётся только после часа освобождения.",
    warnSplitNoop:
      "Деление доли между байерами действует только в режиме «Только выбранные» — сейчас оно ни на что не влияет.",
  },

  validStatuses: {
    label: "Валидные статусы партнёра",
    hint: "Статусы из CRM партнёра, за которые нам платят. Лид в таком статусе считается валидным в «Истории счётчиков» (колонка «% Valid»). FTD-лиды валидны всегда. Регистр не важен.",
    remove: "Убрать {status}",
    placeholder: "Добавить статус и нажать Enter",
    seen: "Статусы, которые присылал партнёр за 90 дней",
    seenLoading: "— загружаем…",
    seenEmpty:
      "Партнёр пока не присылал статусов. Статусы приходят с импортом депозитов и, если CRM партнёра это поддерживает, импортом статусов лидов.",
  },

  integration: {
    listTitle: "Список Итеграций",
    createBreadcrumb: "Создать Интеграции",
    editBreadcrumb: "Редактировать Интеграции",
    costType: "Тип стоимости",
    active: "Активные",
    inactive: "Неактивние",
    validStatusesFor: "Валидные статусы — {name}",
    noAccess: "Нет доступа к этой интеграции",
    saveFailed: "Не удалось сохранить, попробуйте ещё раз",
    historyBreadcrumb: "История",
    historyTitle: "История Cчетчиков",
    validExplainTitle: "Как считается % Valid",
    validExplain:
      "% Valid = (FTD-лиды + лиды со статусом партнёра из списка валидных) ÷ Success-лиды интеграции за выбранный период × 100. Статус партнёра — последний статус лида в CRM партнёра. Список валидных статусов задаётся в настройках интеграции. Итог в строке Total — только по интеграциям, где валидные статусы настроены. Цифра считается по текущим статусам и может меняться, пока партнёр их обновляет.",
    validNotConfigured: "валидные статусы не настроены",
    validList: "валидные: {list}",
    lastWeek: "Прошлая неделя",
    thisWeek: "Эта неделя",
    lastMonth: "Прошлый месяц",
  },

  user: {
    listTitle: "Список Пользователей",
    createBreadcrumb: "Создать Пользователя",
    editBreadcrumb: "Редактировать Пользователя",
  },

  team: {
    listTitle: "Список Команд",
    createBreadcrumb: "Создать Команду",
    editBreadcrumb: "Редактировать Команду",
    detailTitle: "Список Учасников Команды",
  },

  client: {
    breadcrumbTypo: "Клиеты",
    listTitle: "Список Клиентов",
    createBreadcrumb: "Создать Клиента",
    createTitle: "Создать Клиета",
    editBreadcrumb: "Редактировать Клиента",
    editTitle: "Редактировать Клиета",
  },

  country: {},

  spending: {
    breadcrumb: "Pacходы",
    title: "Список Pacходов",
    metaTitle: "Список Расходов",
    uploadOk: "Файл успешно загружен",
    uploadError: "Ошибка чтения файла",
    downloadError: "Ошибка скачивания",
  },

  log: {
    breadcrumb: "Лог",
    title: "Глобальний Лог Распределения",
  },

  report: {
    countryStatsTitle: "Статистика стран",
    campaignHint:
      "Отчет собирается по парсингу из названия Интеграции, тип Интеграции лежит в названии",
    integrationType: "Тип интеграции",
  },

  telegram: {
    reconciliationTitle: "Сверка",
    applySend: "Применить (отправить в тг)",
    nameContainsPlaceholder: "Название (Integration Name Contains)",
    addFilterSet: "Добавить набор фильтров",
  },

  modal: {
    rejectReasonRequired: "Напишите причину отказа!",
  },

  api: {
    downloadError: "Ошибка при скачивании файла",
  },

  bayerInfo: {
    breadcrumb: "Правила работы для Buyer",
    title: "Правила работы для Buyer",
    accessTitle: "1. Регистрация и доступы",
    access1: "1. Получить рабочий email.",
    access2: "2. Зарегистрировать аккаунт в Telegram.",
    access3: "3. Зарегистрировать аккаунт в антидетекте AdsPower.",
    access4: "4. Получить доступы к Keitaro.",
    access5: "5. Получить доступы к Тулу (трекеру).",
    access6: "6. Получить доступы к SPY сервисам.",
    access7: "7. Получить уникальный Buyer ID. Пример: AA88",
    reportTitle: "2. Ежедневный отчёт",
    report1: "1. Получить доступ к Google-таблице с ежедневным отчётом.",
    report1Note: "- Отчёт нужно заполнять каждый день утром за прошлый день.",
    report2: "2. В поле Account ID:",
    report2a: "Записывать каждый новый полученный ID.",
    report2b: "Важно: не дублировать ID (в отчёте один ID = одна строка).",
    report2c: "Перед ID не ставить никаких знаков.",
    report2d:
      "Если Google Sheets автоматически превращает ID в формулу — измените формат ячейки на текстовый.",
    report3: "3. Остальные поля в таблице — заполняются по смыслу (интуитивно понятны).",
    report4: "4. Campaign Report — отдельный отчёт по кампаниям.",
    report4Note: "- Отдельно покажем, как правильно его заполнять.",
    toolTitle: "3. Работа с Тулом",
    tool1: "Все полученные ID рекламных кабинетов обязательно добавлять в тул.",
    tool2: "Это нужно для того, чтобы ID закреплялся за конкретным байером.",
    campaignTitle: "4. Названия кампейнов",
    campaignFormat: "Формат названия для кампейнов(названия оффера в кейтаро):",
    campaignExampleLabel: "Пример:",
    campaignWarning: "Только после этого можно приступать к заливу!",
    noFbId: "Лид который будет передан без FB ID не будет засчитан в",
    profit: "профит!",
  },
  static: {
    sendLeadTo: "Отправка лида в APi:",
    sendLeadWithName: "Отправка лида в APi c разделением name:",
  },
  datePresets: {
    today: "Сегодня",
    last7: "7 дней",
    last30: "30 дней",
    last60: "60 дней",
    thisWeek: "Эта неделя",
    lastWeek: "Прошлая неделя",
    thisMonth: "Этот месяц",
    lastMonth: "Прошлый месяц",
  },
  integrationResponses: {
    metaTitle: "Ответы партнёров",
    breadcrumb: "Интеграции",
    title: "Ответы партнёров",
    from: "с: ",
    to: "по: ",
    classPlaceholder: "Класс ответа",
    integrationPlaceholder: "Интеграция",
    showResolved: "Показать разобранные",
    filter: "Фильтр",
    reset: "Сброс",
    colIntegration: "Интеграция",
    colClass: "Класс",
    colBody: "Ответ партнёра",
    colCount: "Раз",
    colSeen: "Первый / последний",
    colOutcome: "Что с лидом",
    colLeads: "Лиды",
    expand: "показать полностью",
    collapse: "свернуть",
    resolve: "Разобрано",
    resolvedAt: "Разобрано {date}",
    moreLeads: "и ещё {count}",
    empty: "Ответов по этим условиям нет.",
    emptyBody: "партнёр ответил пустым телом",
    classes: {
      unknown: "Не распознан",
      not_accepting: "Партнёр не принимает",
      duplicate: "Дубль",
      invalid_email: "Невалидная почта",
      retry_later: "Повторить позже",
      success: "Успех",
    },
    outcomes: {
      completed: "Закрыт успешно",
      redistributed: "Ушёл на переотбор",
      email_updated: "Сменили почту и повторили",
      error: "Закрыт ошибкой",
      released: "Вернулся в очередь",
    },
  },
};
